export const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "application/pdf",
];
export const ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp", ".pdf"];
export const ACCEPT_FILES = [...ALLOWED_TYPES, ...ALLOWED_EXTENSIONS].join(",");
export const MAX_SIZE_MB = 10;

const hasValidSignature = async (file) => {
  const bytes = new Uint8Array(await file.slice(0, 12).arrayBuffer());
  const startsWith = (sig, offset = 0) =>
    sig.every((b, i) => bytes[offset + i] === b);

  return (
    startsWith([0x25, 0x50, 0x44, 0x46]) || // %PDF
    startsWith([0x89, 0x50, 0x4e, 0x47]) || // PNG
    startsWith([0xff, 0xd8, 0xff]) || // JPEG
    (startsWith([0x52, 0x49, 0x46, 0x46]) && // RIFF....WEBP
      startsWith([0x57, 0x45, 0x42, 0x50], 8))
  );
};

export const validateFile = async (file) => {
  const ext = `.${file.name.split(".").pop().toLowerCase()}`;

  if (!ALLOWED_EXTENSIONS.includes(ext) || !ALLOWED_TYPES.includes(file.type)) {
    return `"${file.name}" is not supported. Upload PNG, JPG, WEBP or PDF only.`;
  }
  if (file.size > MAX_SIZE_MB * 1024 * 1024) {
    return `"${file.name}" exceeds ${MAX_SIZE_MB}MB.`;
  }
  if (!(await hasValidSignature(file))) {
    return `"${file.name}" is not a valid image or PDF.`;
  }
  return null;
};
